import React, { useEffect, useState } from 'react';
import { Row, Col, Button, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
// import editIcon from '../../assets/images/icons/icon-edit.svg';
// import delIcon from '../../assets/images/icons/icon-delete.svg';
import viewIcon from '../../assets/images/icons/viewModalIcon.svg';
import { WebApiCalls } from '../../webApiCalls/WebApiCalls';
// import RouteDetailModal from '../Modals/RouteModals/RouteDetailModal';
// import RouteDelModal from '../Modals/RouteModals/RouteDelModal';
import { toast } from 'react-toastify';
// import RouteEditModal from '../Modals/RouteModals/RouteAddEditModal';
// import RouteAddEditModal from '../Modals/RouteModals/RouteAddEditModal';
import DataTable from 'react-data-table-component';
import _ from 'lodash';
import { useNavigate } from 'react-router-dom';
// import CommonModal from '../Modals/CommonModal';
import { useAuth } from '../../hooks/useAuth';

const RoutesList = () => {
    const [allRoutes, setAllRoutes] = useState();
    const [selectedItem, setSelectedItem] = useState();
    const [showDetailModal, setShowDetailModal] = useState();
    const [showAddEditModal, setShowAddEditModal] = useState(false);
    const [showDelModal, setShowDelModal] = useState(false);
    const [activeNumber, setActiveNumber] = useState(1);
    const [offset, setOffset] = useState(0);
    const [loading, setLoading] = useState(false);
    const [actionType, setActionType] = useState('');
    const [paginationBtns, setPaginationBtns] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [toggleCleared, setToggleCleared] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const [buttonDisable, setButtonDisable] = useState(true);
    const [isFilterSelected, setIsFilterSelected] = useState(false);
    const [changeStatusModal, setChangeStatusModal] = useState(false);
    const [allUnits, setAllUnits] = useState('');
    const { getToken } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        setOffset((s) => {
            if (activeNumber == 1) {
                return 0;
            } else if (activeNumber == 2) {
                return 10;
            } else if (activeNumber == 3) {
                return 20;
            } else if (activeNumber == 4) {
                return 40;
            } else if (activeNumber == 5) {
                return 50;
            }
        });
    }, [activeNumber]);

    const calcPagination = (total) => {
        if (total) {
            const t = (total / 10).toFixed(1);
            if (t > parseInt(t)) {
                setPaginationBtns(parseInt(t) + 1);
            } else {
                setPaginationBtns(parseInt(t));
            }
        } else {
            setPaginationBtns(1);
        }
    };
    useEffect(() => {
        getAllRoutes();
        getMeasuredUnits();
    }, []);

    const getAllRoutes = async (pageSize = 10, pageNo = 0, _transitType, _status, _search) => {
        setLoading(true);
        const token = getToken();
        if (token)
            new WebApiCalls()
                .getAllRoutes(token, '', _transitType, pageSize, pageNo, _status, _search)
                .then((res) => {
                    if (res?.code === 200) {
                        setAllRoutes(res?.data?.routes);
                        calcPagination(res.data?.totalCount);
                        setTotalRecords(res.data?.totalCount);
                        setLoading(false);
                    }
                })
                .catch((err) => {
                    setLoading(false);
                });
        setLoading(false);
    };

    const handleClose = () => {
        setShowDelModal(false);
        setShowDetailModal(false);
        setShowAddEditModal(false);
        setChangeStatusModal(false);
    };

    const handleDelete = async () => {
        const token = getToken();
        if (token && selectedItem?._id) {
            new WebApiCalls()
                .deleteRoute(token, selectedItem?._id)
                .then((res) => {
                    if (res?.code === 200) {
                        toast.success('Route has been deleted successfully.');
                        getAllRoutes();
                    } else {
                        toast.error('Oops...! Something went wrong');
                    }
                })
                .catch((err) => {});
        }
    };
    const getMeasuredUnits = async () => {
        const token = getToken();
        if (token) {
            new WebApiCalls()
                .getRewardSettings(token)
                .then((res) => {
                    if (res?.code == 200) {
                        setAllUnits(res?.data);
                    }
                })
                .catch((err) => {});
        }
    };

    const columns = [
        // {
        //     name: (
        //         <h6 className="text-capitalize mt-2 text-center">
        //             <span className="fw-bold">Agency Name</span>
        //         </h6>
        //     ),
        //     selector: (row) => row.name,
        //     center: true
        //     // sortable: true
        // },
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold">Name</span>
                </h6>
            ),
            selector: (row) => row.name,
            center: true,
            sortable: true
        },
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold ">Transit Type</span>
                </h6>
            ),
            selector: (row) => _.capitalize(row.transit_type),
            sortable: true,
            center: true
        },
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold">Total Retailers</span>
                </h6>
            ),
            selector: (row) => row.noOfVendors,
            sortable: true,
            center: true
        },
        // {
        //     name: (
        //         <h6 className="text-capitalize mt-2 text-center">
        //             <span className="fw-bold">Total Stations</span>
        //         </h6>
        //     ),
        //     selector: (row) => row.noOfStations || 0,
        //     sortable: true,
        //     center: true
        // },
        // {
        //     name: (
        //         <h6 className="text-capitalize mt-2 text-center">
        //             <span className="fw-bold">Avg commuters</span>
        //         </h6>
        //     ),
        //     selector: (row) => (row.avgDailyCommuter ? Math.ceil(row.avgDailyCommuter) : 0),
        //     // sortable: true,/
        //     center: true
        // },

        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold">Service Id</span>
                </h6>
            ),
            selector: (row) => row.service_id,
            center: true,
            sortable: true
        },
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold">Action</span>
                </h6>
            ),
            selector: (row) => (
                <div className="d-flex">
                    <div className="view-detail">
                        <OverlayTrigger delay={{ show: 300, hide: 0 }} placement={'bottom'} overlay={<Tooltip id={`tooltip-bottom`}>View details</Tooltip>}>
                            <div className="edit-detail">
                                <img
                                    width={15}
                                    className="me-3"
                                    src={viewIcon}
                                    alt=""
                                    onClick={() => {
                                        setSelectedItem(row);
                                        navigate('/routes/route-detail', {
                                            state: {
                                                route_id: row._id,
                                                route_details: row
                                            }
                                        });
                                    }}
                                />
                            </div>
                        </OverlayTrigger>
                    </div>
                    {/* <div className="edit-detail">
                        <OverlayTrigger delay={{ show: 300, hide: 0 }} placement={'bottom'} overlay={<Tooltip id={`tooltip-bottom`}>Edit</Tooltip>}>
                            <div className="edit-detail">
                                <img
                                    width={15}
                                    className="me-3"
                                    src={editIcon}
                                    alt=""
                                    onClick={() => {
                                        navigate('edit-route', { state: { route_id: row?._id } });
                                    }}
                                />
                            </div>
                        </OverlayTrigger>
                    </div>
                    <div className="del-detail">
                        <OverlayTrigger delay={{ show: 300, hide: 0 }} placement={'bottom'} overlay={<Tooltip id={`tooltip-bottom`}>Delete</Tooltip>}>
                            <div className="edit-detail">
                                <img
                                    width={15}
                                    className="me-3"
                                    src={delIcon}
                                    alt=""
                                    onClick={() => {
                                        setShowDelModal(true);
                                        setSelectedItem(row);
                                    }}
                                />
                            </div>
                        </OverlayTrigger>
                    </div> */}
                </div>
            ),
            center: true
            // sortable: true
        }
    ];

    const customStyles = {
        rows: {
            style: {
                // minHeight: '72px' // override the row height
                textAling: 'center'
            }
        },
        headCells: {
            style: {
                paddingLeft: '8px', // override the cell padding for head cells
                paddingRight: '8px',
                backgroundColor: '#13aa61',
                color: 'white',
                '&:hover': {
                    cursor: 'pointer'
                }
            }
        }
        // cells: {
        //     style: {
        //         paddingLeft: '8px', // override the cell padding for data cells
        //         paddingRight: '8px'
        //     }
        // }
    };

    const handlePageChange = (pageNo) => {
        // fetchUsers(page);
        getAllRoutes(pageSize, pageNo);
    };

    const handlePerRowsChange = async (pageSize, pageNo) => {
        getAllRoutes(pageSize, pageNo);
        setPageSize(pageSize);
        setLoading(false);
    };

    const handleRowSelected = React.useCallback((state) => {
        const selectedIds = state.selectedRows.map((item) => {
            return item._id;
        });
        setSelectedRows(selectedIds);
    }, []);

    useEffect(() => {
        if (selectedRows && selectedRows.length > 0) {
            setButtonDisable(false);
        } else {
            setButtonDisable(true);
        }
    }, [selectedRows]);

    const searchDebounce = _.debounce((text) => {
        getAllRoutes(undefined, undefined, '', '', text);
    }, 2000);

    const updateBulk = async (status) => {
        try {
            setLoading(true);
            const token = getToken();
            let obj = {
                _ids: selectedRows,
                status: status
            };
            if (token)
                new WebApiCalls()
                    .updateBulkRoute(token, obj)
                    .then((res) => {
                        if (res?.code === 200) {
                            getAllRoutes();
                            setLoading(false);
                            toast.success('Routes are updated successfully.');
                            setToggleCleared(true);
                            setSelectedRows();
                        }
                    })
                    .catch((err) => {
                        setLoading(false);
                    });
            setLoading(false);
        } catch (error) {
            console.log('ERROR while updating Bulk', error);
        }
    };

    const deleteBulk = async () => {
        try {
            setLoading(true);
            const token = getToken();
            let obj = {
                _ids: selectedRows
            };
            if (token)
                new WebApiCalls()
                    .deleteBulkRoute(token, obj)
                    .then((res) => {
                        if (res?.code === 200) {
                            getAllRoutes();
                            setLoading(false);
                            toast.success('Routes are delete successfully.');
                            setToggleCleared(true);
                            setSelectedRows();
                        } else {
                            toast.error('Oops...! Something went wrong');
                        }
                    })
                    .catch((err) => {
                        setLoading(false);
                    });
            setLoading(false);
        } catch (error) {
            console.log('ERROR while updating Bulk', error);
        }
    };

    const updateSingle = async (selectedId, body) => {
        try {
            setLoading(true);
            const token = getToken();
            if (token)
                new WebApiCalls()
                    .updateRoute(token, body, selectedId)
                    .then((res) => {
                        if (res?.code === 200) {
                            getAllRoutes();
                            setLoading(false);
                            toast.success('Route is updated successfully.');
                            setToggleCleared(true);
                            setSelectedRows();
                        } else {
                            toast.error('Oops...! Something went wrong');
                        }
                    })
                    .catch((err) => {
                        setLoading(false);
                    });
            setLoading(false);
        } catch (error) {
            console.log('ERROR while updating Bulk', error);
        }
    };

    return (
        <div style={{ padding: '20px' }}>
            <Modal centered show={changeStatusModal} onHide={handleClose} size="md">
                <Modal.Header closeButton onClick={handleClose}>
                    <Modal.Title className="text-center">
                        <h6 className="text-capitalize mt-2">
                            <span className=" breadcrumb-heading">Change Status</span>
                        </h6>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center">
                    {/* <div className="icon-warning-wrapper my-1 mt-1"><img src={warningIcon} alt="" /></div> */}
                    <p className="mx-4 my-4 px-5">Are you sure you want to change status?</p>
                    <div className="text-content-wrapper mt-3">
                        <div>
                            <Button
                                className="add-record-btn  justify-content-center w-140"
                                style={{ background: '#198754' }}
                                onClick={() => {
                                    setChangeStatusModal(false);
                                    updateBulk('active');
                                }}
                            >
                                Active
                            </Button>
                        </div>
                        <div>
                            <Button
                                className="add-record-btn  justify-content-center w-140"
                                style={{ background: '#F32013' }}
                                onClick={() => {
                                    setChangeStatusModal(false);
                                    updateBulk('inactive');
                                }}
                            >
                                Inactive
                            </Button>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer className="border-0 mt-2"></Modal.Footer>
            </Modal>
            {/* <CommonModal handleClose={handleClose} show={showDelModal} handleDelete={handleDelete} text={'Are you sure, you want to delete this Route?'} /> */}
            <Row className="mb-4 mt-1">
                <Col sm={3} md={3} style={{ paddingRight: 0 }}>
                    <input
                        type={'search'}
                        className="search-input-bar"
                        placeholder={'Search here...'}
                        onChange={(e) => {
                            e.preventDefault();
                            searchDebounce(e.target.value);
                        }}
                    />
                </Col>
                <Col sm={4} md={4} style={{ paddingLeft: 0 }}>
                    <div className="d-flex gap-10 justify-content-start">
                        <h6 className="text-capitalize mt-2 text-center">
                            {/* <span className="fw-bold" style={{ whiteSpace: 'nowrap' }}>
                                Filter By
                            </span> */}
                        </h6>
                        <select
                            onChange={(e) => {
                                getAllRoutes(undefined, undefined, e.target.value);
                                setIsFilterSelected(e.target.value ? true : false);
                            }}
                            className="status-selector w-120"
                            aria-label="Default select example"
                            style={{ color: !isFilterSelected ? '#9a9a9a' : '' }}
                        >
                            <option value={''}>Transit Type</option>
                            <option value={'bus'}>Bus</option>
                            <option value={'streetcar'}>Street Car</option>
                            <option value={'subway'}>Subway</option>
                            <option value={'train'}>Train</option>
                        </select>
                        <select
                            onChange={(e) => {
                                getAllRoutes(undefined, undefined, '', e.target.value);
                                setIsFilterSelected(e.target.value ? true : false);
                            }}
                            className="status-selector w-120"
                            aria-label="Default select example"
                            style={{ color: !isFilterSelected ? '#9a9a9a' : '' }}
                        >
                            <option>Status</option>
                            <option value={'active'}>Active</option>
                            <option value={'inactive'}>Inactive</option>
                        </select>
                    </div>
                </Col>
                <Col sm={5} md={5}>
                    <div className="d-flex gap-10 justify-content-end h-100">
                        {!buttonDisable && (
                            <>
                                <Button
                                    className="add-record-btn  justify-content-center w-140"
                                    style={{ background: '#F3D119', color: 'black' }}
                                    onClick={(e) => {
                                        // updateBulk('active');
                                        setChangeStatusModal(true);
                                        // setActionType('add');
                                        // setShowAddEditModal(true);
                                    }}
                                    disabled={buttonDisable}
                                >
                                    Change Status
                                    {/* {activeButton} */}
                                </Button>
                                <Button
                                    className="add-record-btn  justify-content-center w-140"
                                    style={{ background: 'red' }}
                                    onClick={(e) => {
                                        deleteBulk();
                                        // setActionType('add');
                                        // setShowAddEditModal(true);
                                    }}
                                    disabled={buttonDisable}
                                >
                                    Delete
                                </Button>
                            </>
                        )}
                        {/* {buttonDisable && (
                            <Button
                                className="add-record-btn justify-content-center  w-140"
                                style={{ background: '#13aa61' }}
                                onClick={(e) => {
                                    navigate('add-route');
                                    // setActionType('add');
                                    // setShowAddEditModal(true);
                                }}
                            >
                                Add
                            </Button>
                        )} */}
                    </div>
                    {/* </Col> */}
                </Col>
            </Row>
            <DataTable
                columns={columns}
                data={allRoutes}
                selectableRows
                pagination
                paginationServer
                paginationTotalRows={totalRecords}
                onChangeRowsPerPage={handlePerRowsChange}
                onChangePage={handlePageChange}
                progressPending={allRoutes && allRoutes?.length >= 0 ? false : true}
                responsive
                direction="auto"
                fixedHeaderScrollHeight="300px"
                subHeaderAlign="right"
                subHeaderWrap
                customStyles={customStyles}
                onSelectedRowsChange={handleRowSelected}
                clearSelectedRows={toggleCleared}
                // defaultSortFieldId={1}
            />
        </div>
    );
};
export default RoutesList;
